module.exports = __webpack_public_path__ + "img/zixun_2.fcc033d.png";